/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { ProcessCardsComponentDisplay } from "cms/components/components/process-cards/display";
import { ProcessCardsComponentEditor } from "cms/components/components/process-cards/edit";

const ProcessCardsComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ProcessCardsComponentDisplay />,
        editComponent: <ProcessCardsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ProcessCardsComponent.displayName = "ProcessCardsComponent";
export { ProcessCardsComponent };
